module.exports = __webpack_public_path__ + "img/yonghuchaxun.a206e7a5.png";